'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondsAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/millisecondsAfter.js
// module id = 699
// module chunks = 0